/** מטמון קל לרשימת הזמנות (summary) — פתיחה מיידית גם ב־3G */

const PREFIX = "reshet_orders_summary_v1_";

export function ordersListCacheKey({ storeId = "", filterStoreId = "", search = "" } = {}) {
  const sid = String(filterStoreId || storeId || "me");
  const q = String(search || "").trim().toLowerCase();
  return `${PREFIX}${sid}_${q || "all"}`;
}

export function loadOrdersListCache(key) {
  if (!key || typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed?.orders)) return null;
    return {
      orders: parsed.orders,
      savedAt: Number(parsed.savedAt) || 0,
    };
  } catch {
    return null;
  }
}

export function saveOrdersListCache(key, orders) {
  if (!key || typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(
      key,
      JSON.stringify({
        orders: Array.isArray(orders) ? orders : [],
        savedAt: Date.now(),
      })
    );
  } catch (e) {
    console.warn("ordersListCache save failed", e?.message || e);
  }
}
